import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {TeamService} from '@core/services/team.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-news-register-reporter',
  templateUrl: './news-register-reporter-dialog.component.html',
  styleUrls: [
    '../news-dialogs-styles.scss',
    './news-register-reporter-dialog.component.scss'
  ]
})
export class NewsRegisterReporterDialogComponent implements OnInit {

  public form = new FormGroup({
    email: new FormControl('', Validators.compose([Validators.email, Validators.required])),
    phone: new FormControl(''),
    text: new FormControl(''),
  });
  public teamName = 'deinem Team';
  public sendButtonDisabled = false;
  public showErrorLabel = false;
  public showAlreadyRegisteredLabel = false;
  public showSuccessLabel = false;

  public static getDialogSize(): MatDialogConfig {
    return {
      maxWidth: '600px', width: '80vw', maxHeight: '90vh'
    };
  }

  constructor( @Inject(MAT_DIALOG_DATA) public data: any,
               public dialogRef: MatDialogRef<NewsRegisterReporterDialogComponent>,
               private teamService: TeamService ) { }

  public ngOnInit(): void {
    const currentTeam = this.teamService.currentTeam;
    if (currentTeam) {
      this.teamName = currentTeam.name;
    }
  }

  public async onRegister(): Promise<void> {
    this.showErrorLabel = false;
    this.showAlreadyRegisteredLabel = false;

    if (this.form.valid === false || this.sendButtonDisabled) {
      return;
    }
    if (this.teamService.currentTeam == null || this.teamService.currentTeam.id == null) {
      return;
    }
    this.sendButtonDisabled = true;

    if (!(this.data.firstName && this.data.lastName)) {
      this.showErrorLabel = true;
      return;
    }

    const teamId = this.teamService.currentTeam.id;
    const response: { success, error } = await this.teamService.applyForTeamModeration(teamId,
      this.data.firstName,
      this.data.lastName,
      this.form.value.email,
      this.form.value.phone,
      this.form.value.text
    );
    if (response.success) {
      this.showSuccessLabel = true;
      return;
    }
    if (response.error === 403) {
      this.showAlreadyRegisteredLabel = true;
    } else {
      this.showErrorLabel = true;
    }
    this.sendButtonDisabled = false;

  }

}
